/* eslint-disable i18next/no-literal-string */
import {Text} from '@dropbox/dig-components/typography';
import {Stack} from '@dropbox/dig-foundations';
import type {AskHealthWeek} from 'client';

import styles from './AskHealth.module.css';
import {percent, seconds, weekLabel} from './format';
import {StatTile} from './StatTile';

const wasNote = (was?: string) =>
  was === undefined ? 'no earlier week logged' : `was ${was} the week before`;

export const StatTiles = ({
  latest,
  previous,
}: {
  latest: AskHealthWeek;
  previous?: AskHealthWeek;
}) => (
  <Stack gap="8">
    <Text tagName="div" size="small" color="subtle">
      {latest.complete
        ? `Week of ${weekLabel(latest)}, the last full week`
        : `Week of ${weekLabel(latest)}, no full week logged yet`}
    </Text>
    <div className={styles.tiles}>
      <StatTile
        label="Answer quality (judge)"
        value={percent(latest.quality)}
        note={wasNote(previous && percent(previous.quality))}
      />
      <StatTile
        label="Fully answered"
        value={percent(latest.answered)}
        note={wasNote(previous && percent(previous.answered))}
      />
      <StatTile
        label="Median answer time"
        value={seconds(latest.median_seconds)}
        note={wasNote(previous && seconds(previous.median_seconds))}
      />
      <StatTile
        label="Slowest 10%"
        value={seconds(latest.p90_seconds)}
        note={wasNote(previous && seconds(previous.p90_seconds))}
      />
      <StatTile
        label="Sent to the Dash agent"
        value={percent(latest.dash_agent)}
        note={wasNote(previous && percent(previous.dash_agent))}
      />
      <StatTile
        label="Questions asked"
        value={`${latest.questions}`}
        note={wasNote(previous && `${previous.questions}`)}
      />
    </div>
  </Stack>
);
